import React from "react";
import ListAccountContainer from "../../containers/Account";

const AccountScreen = () => {
  return <ListAccountContainer />;
};

export default AccountScreen;
